import { ConversationStatus, MessageContentCategory, MessageContentType, SectionType } from '@rocketlane/rocket-llm';
export const RM_COPILOT_NAME = 'rm_agent';
const isTextOrMarkdownType = (type)=>type === MessageContentType.TEXT || type === MessageContentType.MARKDOWN;
const buildSection = (section, idx)=>{
    var _ref, _section_left_content_title;
    var _section_left_content, _section_left_content1, _section_left_content2;
    const lcType = ((_section_left_content = section.left_content) === null || _section_left_content === void 0 ? void 0 : _section_left_content.type) || 'text';
    const rawValue = ((_section_left_content1 = section.left_content) === null || _section_left_content1 === void 0 ? void 0 : _section_left_content1.value) || '';
    const value = isTextOrMarkdownType(lcType) && typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    return {
        order_index: idx,
        ...section.id !== undefined ? {
            id: section.id
        } : {},
        type: section.type || SectionType.TEXT,
        title: (_ref = (_section_left_content2 = section.left_content) === null || _section_left_content2 === void 0 ? void 0 : _section_left_content2.title) !== null && _ref !== void 0 ? _ref : undefined,
        status: section.status,
        timestamp: section.timestamp ? new Date(section.timestamp) : undefined,
        left_content: section.left_content ? {
            type: lcType,
            category: MessageContentCategory.SUMMARY,
            title: (_section_left_content_title = section.left_content.title) !== null && _section_left_content_title !== void 0 ? _section_left_content_title : undefined,
            value
        } : {
            type: MessageContentType.TEXT,
            category: MessageContentCategory.SUMMARY,
            value: ''
        },
        ...section.right_content ? {
            right_content: {
                type: section.right_content.type || 'text'
            }
        } : {}
    };
};
const buildMessage = (msg)=>{
    var _msg_metadata, _msg_feedback_type, _msg_created_at, _msg_updated_at;
    return {
        id: msg.id,
        conversation_id: msg.conversation_id,
        user_id: msg.user_id,
        type: msg.type,
        sections: (msg.sections || []).filter((s)=>{
            if (!s.left_content) {
                return false;
            }
            const type = s.left_content.type || 'text';
            const val = s.left_content.value;
            if (isTextOrMarkdownType(type) && typeof val === 'string') {
                return val.trim().length > 0;
            }
            return true;
        }).map(buildSection),
        version: msg.version || 1,
        is_edited: msg.is_edited || false,
        agents_ids: msg.agents_ids || [],
        metadata: (_msg_metadata = msg.metadata) !== null && _msg_metadata !== void 0 ? _msg_metadata : {},
        is_streaming: msg.is_streaming || false,
        is_deleted: msg.is_deleted || false,
        feedback_type: (_msg_feedback_type = msg.feedback_type) !== null && _msg_feedback_type !== void 0 ? _msg_feedback_type : undefined,
        has_feedback: msg.has_feedback || msg.feedback_type != null,
        // The API and `@rocketlane/rocket-llm` Message both use ISO strings for
        // created_at / updated_at — pass through (null → undefined).
        created_at: (_msg_created_at = msg.created_at) !== null && _msg_created_at !== void 0 ? _msg_created_at : undefined,
        updated_at: (_msg_updated_at = msg.updated_at) !== null && _msg_updated_at !== void 0 ? _msg_updated_at : undefined
    };
};
export const convertRmCopilotResponseToConversation = (data)=>{
    var _data_conversation_updated_at;
    const transformedMessages = (data.messages || []).map(buildMessage);
    return {
        conversation_id: data.conversation.conversation_id,
        title: data.conversation.title || 'RM Agent Conversation',
        user_ids: data.conversation.user_ids,
        status: data.conversation.status === 'active' ? ConversationStatus.Active : ConversationStatus.InProgress,
        is_deleted: data.conversation.is_deleted,
        active_version: data.conversation.active_version,
        messages: transformedMessages,
        metadata: data.conversation.metadata,
        tags: data.conversation.tags,
        created_at: data.conversation.created_at,
        updated_at: (_data_conversation_updated_at = data.conversation.updated_at) !== null && _data_conversation_updated_at !== void 0 ? _data_conversation_updated_at : undefined
    };
};
export const getRmCopilotSendMessagePayload = ({ message, conversationId, accountId, userId, /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ sectionType, conversation_metadata, message_sections })=>{
    const payload = {
        conversation_id: conversationId,
        account_id: accountId,
        user_id: userId,
        message: {
            sections: message_sections || [
                {
                    type: 'text',
                    left_content: {
                        type: 'text',
                        category: MessageContentCategory.SUMMARY,
                        value: message
                    }
                }
            ]
        },
        ...(conversation_metadata === null || conversation_metadata === void 0 ? void 0 : conversation_metadata.agent_id) && (conversation_metadata === null || conversation_metadata === void 0 ? void 0 : conversation_metadata.agent_name) ? {
            conversation_metadata: {
                agent_id: conversation_metadata.agent_id,
                agent_name: RM_COPILOT_NAME,
                agent_title: conversation_metadata.agent_name
            }
        } : {
            conversation_metadata: {
                agent_name: RM_COPILOT_NAME
            }
        }
    };
    return payload;
};
export const getFeedbackPayload = ({ messageId, accountId, userId, feedbackType, feedbackCategory, feedbackText })=>({
        message_id: messageId,
        account_id: accountId,
        user_id: userId,
        feedback_type: feedbackType,
        feedback_category: feedbackCategory,
        feedback_text: feedbackText
    });
